import { Row } from "@tanstack/react-table";

import { PostalCodeWithAgencyType } from "@/codegen/openapi2";

import { GeographicalAgencyTypeOptionsType } from "./geographical-agency-type-options";
import { GeographicalAgencyTypeTag } from "./geographical-agency-type-tag";

const getGeographicalAgencyTypeValue = (
  coreAgency: boolean | null,
  closeCoreAgency: boolean | null
): GeographicalAgencyTypeOptionsType | null => {
  if (coreAgency) return "coreAgency";
  if (closeCoreAgency) return "closeCoreAgency";
  if (coreAgency === false && closeCoreAgency === false) return "nonCoreAgency";
  return null;
};

type GeographicalAgencyTypeCellProps = {
  row: Row<PostalCodeWithAgencyType>;
  handleUpsert?: (
    row: PostalCodeWithAgencyType,
    agencyUuid: string,
    coreAgency: boolean | null,
    closeCoreAgency: boolean | null
  ) => void;
};
export const GeographicalAgencyTypeCell = ({
  row,
  handleUpsert,
}: GeographicalAgencyTypeCellProps) => {
  const geographicalAgencyTypeValue = getGeographicalAgencyTypeValue(
    row.original.core_agency,
    row.original.close_core_agency
  );

  const agencyUuid = row.original.agency_uuid;
  if (!geographicalAgencyTypeValue || !agencyUuid) {
    return null;
  }

  return (
    <GeographicalAgencyTypeTag
      geographicalAgencyTypeValue={geographicalAgencyTypeValue}
      onChange={
        handleUpsert
          ? (core_agency, close_core_agency) => {
              handleUpsert(row.original, agencyUuid, core_agency, close_core_agency);
            }
          : undefined
      }
    />
  );
};
